export default __webpack_public_path__ + "static/media/langchainApp.130ba4ba.svg";